import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchAddOfferToComparison } from '../../shared/repositories/offers-comparison/v2/add-offer-to-comparison';
import { EComparisonNotificationCategory } from '../../types/comparison';
import { assertBadHttpStatus } from './assert/assertBadHttpStatus';
export function addToComparison(_x) {
  return _addToComparison.apply(this, arguments);
}
function _addToComparison() {
  _addToComparison = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var httpApi, logger, params, response, _response, success, text, comparisonUrl, offerId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = _ref.httpApi, logger = _ref.logger, params = _ref.params;
          _context.prev = 1;
          _context.next = 4;
          return fetchAddOfferToComparison({
            httpApi: httpApi,
            parameters: params
          });
        case 4:
          response = _context.sent;
          assertBadHttpStatus(response);
          _response = response.response, success = _response.success, text = _response.text, comparisonUrl = _response.comparisonUrl, offerId = _response.offerId;
          return _context.abrupt("return", {
            text: text,
            url: comparisonUrl,
            category: success ? EComparisonNotificationCategory.Add : EComparisonNotificationCategory.Limit,
            offerId: offerId
          });
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            offerId: params.offerId,
            domain: 'addToComparison'
          });
        case 13:
          return _context.abrupt("return", null);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _addToComparison.apply(this, arguments);
}